import { baseApiUrl, deployPath } from './global'
import axios from 'axios'
import store from '@/store'

const axiosInstance = axios.create({
  baseURL: baseApiUrl,
  withCredentials: true,
})

axiosInstance.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error.response) {
      if (error.response.status === 401) {
        localStorage.clear()
        store.dispatch('setError', {
          message: 'Sessão expirada, direcionando para página de login.',
        })
        localStorage.setItem('user', null)
        window.location.href = '/login'
        // window.location.href = `${deployPath}/login`
        store.dispatch('setError', {
          message: error.response.data.message || 'An error occurred',
        })
      } else if (error.response.status === 403) {
        store.dispatch('setError', {
          message: error.response.data.message || 'An error occurred',
        })
      }
    }
    return Promise.reject(error)
  }
)

export default axiosInstance
